var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"actionButton",on:{"click":_vm.doClick}},[_c('div',{staticClass:"mark"},[_c('IconBase',{attrs:{"iconName":"編集"}},[_c('IconPencil')],1)],1),_c('div',{staticClass:"txt"},[_vm._v("編集")])])
}
var staticRenderFns = []

export { render, staticRenderFns }